{
  "nl": {
    "upsell": {
      "categories": {
        "category": "Categorie",
        "home_automation": "Domotica",
        "integration": "Integratie",
        "interior_decoration": "Interieurdecoratie",
        "interior_doors": "Binnendeuren",
        "kitchen": "Keuken",
        "marketing": "Marketing",
        "real_estate_agent": "Makelaar",
        "telecom": "Telecom",
        "wood_finishing": "Houtafwerking"
      },
      "contact_us": "Geïnteresseerd? Neem contact op!",
      "decisions_partners": {
        "guidance": "Beslissingspartners kunnen voorstellen maken en/of beheren als ze daarvoor toestemming hebben gekregen.<br>Je kan meer lezen over beslissingspartners <a class='is-underlined' href='/help/content/partners/ partners.html#decision-partners' target='_blank'>hier</a>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Beslissingspartners. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Chat met ons voor meer informatie",
        "description": "Ben je het beu om een voorstel af te keuren om enkele wijzigingen toe te voegen en helemaal opnieuw te beginnen? Meerdere goedkeuringen nodig hebben zou je niet moeten vertragen.",
        "description_2": "Laat je klanten meerdere voorstellen goedkeuren in dezelfde beslissing. Je hoeft een bestaand voorstel niet goed te keuren of een nieuwe beslissing te starten.",
        "description_3": "Minder gedoe en meer tijd om je te richten op wat echt belangrijk is: je klant!",
        "intercom": "Hallo Ziggu! Ik wil dat de klant meerdere voorstellen kan goedkeuren binnen een beslissing. Kun je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "premium_add_on": "Premium uitbreiding",
        "title": "Bespaar tijd met de flexibele voorstellen add-on!"
      },
      "decisions_reminders": {
        "guidance": "Met herinneringen kunt u klanten automatisch laten weten dat er voorstellen wachten op een beslissing.<br>Je kan meer lezen over herinneringen <a class='is-underlined' href='/help/content/decisions/decisions.html?#step-3-optional-settings' target='_blank'>hier</a>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Herinneringen. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "financials": {
        "guidance": "Maak betalingsschijven aan op basis van goedgekeurde voorstellen en deel ze met je klanten via het klantenportaal.<br>Houd je financiële communicatie transparant en professioneel, klanten hebben altijd een duidelijk overzicht van wat er verschuldigd is en wanneer.",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de Financiën-functie voor termijnen bij beslissingen. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "imInterested": "Ik heb interesse!",
      "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in {upsell}. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
      "interestedToBeListed": "Geïnteresseerd om hier vermeld te worden",
      "lookingfor": "Waar ben je naar op zoek? Bv. 3D visualisatie, keukens, telecom, ...",
      "not_included": "Geïnteresseerd in deze functionaliteit?",
      "project_email_forwarding": {
        "cta": "E-mails doorsturen naar {project_name}",
        "description": "Laat iedereen binnen je team e-mails rechtstreeks doorsturen naar je Ziggu-projecten.",
        "intercom": "Hallo Ziggu! Ik wil graag e-mails doorsturen naar projecten. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "marketplace": {
          "title": "Project email forwarding",
          "title_sub": "E-mails rechtstreeks doorsturen naar je Ziggu-projecten."
        },
        "title": "Nieuw! E-mails doorsturen naar projecten",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Je mag mij contacteren hierover!",
        "cta": "Op zoek naar een betere projectervaring?",
        "description": "Gepersonaliseerde project-URL en inlogscherm <br/> Eigen projectomgeving wanneer ingelogd <br/> Project branded e-mails <br/> Maakt projectsamenwerking met andere vastgoedontwikkelaars eenvoudiger",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de Project Experience-module. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "marketplace": {
          "title": "Project experience",
          "title_sub": "Verbeter uw projectbranding met een gepersonaliseerde project-URL en -omgeving"
        },
        "title": "Laat jouw klanten zich thuis voelen met de gloednieuwe Project Experience!",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "Importeer een sjabloon?",
        "cta2": "Deze sjabloon importeren in uw projecten? Klik hier om deze functie te ontgrendelen!",
        "description": "<p>Transformeer hoe je projecten beheert met vooraf gebouwde sjablonen die je tijd besparen en je team op één lijn houden.</p><br>\n<p><strong>Voordelen van sjablonen:</strong></p>\n<ul>\n    <li><strong>- Bespaar uren</strong> op repetitieve taken—importeer volledige projectstructuren in seconden.</li>\n    <li><strong>- Verbeterde standaardisatie</strong> door alles op één plek te hebben, van taken tot documenten.</li>\n    <li><strong>- Verhoog de efficiëntie</strong> door routinetaken te automatiseren, zodat je je kunt richten op wat het meest belangrijk is.</li>\n</ul>\n<br/><strong>Upgrade vandaag nog en krijg meer gedaan met minder moeite!</strong>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de sjablonen functionaliteit, kan je mij wat meer informatie geven hierover? Groeten, %{name}",
        "marketplace": {
          "title": "Sjablonen",
          "title_sub": "Transformeer hoe je projecten beheert met vooraf gebouwde sjablonen die je tijd besparen en je team op één lijn houden."
        },
        "title": "Werk slimmer met sjablonen!"
      },
      "proposal_choice_lists": {
        "guidance": "Met keuzelijsten kunt u klanten keuzes laten maken in voorstellen.<br>Je kan meer lezen over keuzelijsten <a class='is-underlined' href='/help/content/decisions/decisions.html#choice-list' target='_blank'>hier</a>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Keuzelijsten. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "signatures": {
        "cta_text": "Handtekeningen nodig voor uw documenten? Neem contact op",
        "guidance": "Met handtekeningen kunt u klanten belangrijke documenten digitaal laten ondertekenen.<br>Je kan meer lezen over herinneringen <a class='is-underlined' href='/help/content/decisions/decisions.html#electronic-signature' target='_blank'>hier</a>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Handtekeningen. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      }
    }
  }
}
